import { useStore } from '../state/zustand-store';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Lock from '@mui/icons-material/Lock';
interface ChangeLogRequiredOverlayProps {
  onOpenDialog: () => void;
  permissionName: string;
}
export default function ChangeLogRequiredOverlay({
  onOpenDialog,
  permissionName,
}: ChangeLogRequiredOverlayProps) {
  const { colorMode } = useStore();
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
        textAlign: 'center',
        px: 2,
        bgcolor: (theme) =>
          colorMode === 'light'
            ? theme.palette.grey[100]
            : theme.palette.grey[900],
      }}
    >
      {' '}
      <Stack direction="row" alignItems="center" spacing={1}>
        {' '}
        <Lock />{' '}
        <Typography variant="h5">Change Log Reason Required</Typography>{' '}
      </Stack>{' '}
      <Typography variant="body1" mt={1} mb={2}>
        {' '}
        Change log for "{permissionName}" has been enabled.{' '}
      </Typography>{' '}
      <Button variant="contained" onClick={onOpenDialog}>
        {' '}
        Provide reason{' '}
      </Button>{' '}
    </Box>
  );
}
